import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import VideoModal from "../components/VideoModal";
import "../styles/Home.css";

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);
  const [isEventExpanded, setIsEventExpanded] = useState(false);

  // Hero Carousel State and Slides Data
  const heroSlides = [
    {
      id: 1,
      image: "/image/dashera.png",
      alt: "Dashera Banner",
    },
    {
      id: 2,
      image: "/image/sharadpunam0.png",
      alt: "Sharad Punam Banner",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  }, [heroSlides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide(
      (prev) => (prev - 1 + heroSlides.length) % heroSlides.length,
    );
  }, [heroSlides.length]);

  // Auto-scroller (every 5 seconds, pauses on hover)
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [isPaused, nextSlide]);

  const openVideoModal = (videoId, title) => {
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };
  const pravachanSections = [
    {
      id: 1,
      title: "Hari Paramrut",
      image: "image/hariparamrut.jpg",
      link: "pravachan/hari-paramrut",
    },
    {
      id: 2,
      title: "Akshar Vani",
      image: "image/aksharvani.jpg",
      link: "pravachan/akshar-vani",
    },
    {
      id: 3,
      title: "Akshar Vani Two",
      image: "image/aksharvanitwo.jpg",
      link: "pravachan/akshar-vani-two",
    },
    {
      id: 4,
      title: "Mara Swamiji",
      image: "image/maraswamiji.jpg",
      link: "pravachan/mara-swamiji",
    },
    {
      id: 5,
      title: "Sant Vani",
      image: "image/santvani.jpg",
      link: "pravachan/sant-vani",
    },
    {
      id: 6,
      title: "Sant Vani Two",
      image: "image/santvanitwo.jpg",
      link: "pravachan/sant-vani-two",
    },
    {
      id: 7,
      title: "Mara Guruhari",
      image: "image/maraguruhari.jpg",
      link: "pravachan/mara-guruhari",
    },
    {
      id: 8,
      title: "Baheno Pravachan",
      image: "image/sadhak.jpg",
      link: "pravachan/Baheno-Pravachan",
    },
    {
      id: 9,
      title: "Vakta",
      image: "image/vakta.jpg",
      link: "pravachan/vakta",
    },
    {
      id: 10,
      title: "Sevak Pravachan",
      image: "image/sevak.jpg",
      link: "pravachan/sevak-pravachan",
    },
    {
      id: 11,
      title: "Haribhakt Pravachan",
      image: "image/haribhakt.jpg",
      link: "pravachan/haribhakt-pravachan",
    },
  ];

  const darshanSections = [
    {
      id: 1,
      title: "Sahaj Darshan",
      image: "image/sahajdarshan.jpg",
      link: "darshan/sahaj",
    },

    {
      id: 2,
      title: "Pragatya Parv",
      image: "image/pragatyadin.jpg",
      link: "darshan/pragatya",
    },
    {
      id: 3,
      title: "Smruti",
      image: "image/smruti.jpg",
      link: "https://smruti.ihariprabodham.in",
    },
  ];

  const videshYatraSections = [
    {
      id: 1,
      title: "USA",
      image: "image/usa.jpg",
      link: "pravachan/usa-yatra",
    },
    {
      id: 2,
      title: "Canada",
      image: "image/canada.jpg",
      link: "pravachan/canada-yatra",
    },
    {
      id: 3,
      title: "Europe",
      image: "image/uk.jpg",
      link: "pravachan/europe-yatra",
    },
  ];

  const hpymEvents = [
    {
      id: 1,
      title: "HPYM 2025",
      date: "Jan 5, 2025",
      image: "https://img.youtube.com/vi/tUct-rIG_Cs/mqdefault.jpg",
      videoId: "tUct-rIG_Cs",
    },
    {
      id: 2,
      title: "HPYM 2024",
      date: "Jan 7, 2024",
      image: "https://img.youtube.com/vi/Hy6FHLfQjcI/mqdefault.jpg",
      videoId: "Hy6FHLfQjcI",
    },
    {
      id: 3,
      title: "HPYM 2023",
      date: "Jan 8, 2023",
      image: "https://img.youtube.com/vi/89zLnHB0CfE/mqdefault.jpg",
      videoId: "89zLnHB0CfE",
    },
    {
      id: 4,
      title: "Gurubhakti Mahotsav 2022",
      date: "May 22, 2022",
      image: "https://img.youtube.com/vi/EAOfBRQpRtY/mqdefault.jpg",
      videoId: "EAOfBRQpRtY",
    },
  ];

  return (
    <main className="home">
      <section className="hero-banner">
        <div className="hero-content">
          {/* <div
            className="event-announcement-bar"
            onClick={() => setIsEventExpanded(!isEventExpanded)}
          >
            <span className="event-badge">New</span>
            <span className="event-live-badge"></span>
            <span className="event-text">Avo.. Kariye Guru GunGan</span>
            <span
              className={`event-arrow ${isEventExpanded ? "expanded" : ""}`}
            >
              ▼
            </span>
          </div>
          {isEventExpanded && (
            <div className="event-video-panel">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  marginTop: "40px",
                  marginBottom: "40px",
                }}
              >
                <Link
                  to="https://youtu.be/HsGs9oDO9W8?si=6fmguxyQRTdXtEm9"
                  className="hero-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ margin: "0 10px" }}
                >
                  Listen on YouTube
                </Link>
                <Link
                  to="https://music.apple.com/in/album/aavo-kariye-guru-gun-gaan/1868188581?i=1868188582"
                  className="hero-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ margin: "0 10px" }}
                >
                  Listen on Apple Music
                </Link>
                <Link
                  to="https://open.spotify.com/album/4GtCDxHoebRuirt4T3EgvQ?si=eZrBHOPiRSOxK91V6AGBMQ"
                  className="hero-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ margin: "0 10px" }}
                >
                  Listen on Spotify
                </Link>
              </div>
            </div>
          )} */}
          <div
            className="hero-slider"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {/* Sliding Track */}
            <div
              className="hero-slider-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {heroSlides.map((slide) => (
                <div className="hero-slide" key={slide.id}>
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    className="hero-image"
                  />
                </div>
              ))}
            </div>

            {/* Prev Button */}
            <button
              type="button"
              className="carousel-control prev"
              onClick={prevSlide}
              aria-label="Previous Slide"
            >
              &#10094;
            </button>

            {/* Next Button */}
            <button
              type="button"
              className="carousel-control next"
              onClick={nextSlide}
              aria-label="Next Slide"
            >
              &#10095;
            </button>

            {/* Bottom Indicator Dots */}
            <div className="carousel-indicators">
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={`indicator-dot ${currentSlide === index ? "active" : ""}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
          {/*   <div className="hero-overlay">
            <Link
              to="https://ihariprabodham.org/MariSmruti/login"
              className="hero-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mari Smruti
            </Link>
          </div> */}
        </div>
      </section>

      <section className="pravachan-section">
        <h2>Pravachan</h2>
        <div className="card-grid card-grid--compact">
          {pravachanSections.map((item) => (
            <Link key={item.id} to={item.link} className="card">
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="pravachan-section">
        <h2>Videsh Yatra Pravachan</h2>
        <div className="card-grid card-grid--compact">
          {videshYatraSections.map((item) => (
            <Link key={item.id} to={item.link} className="card">
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="darshan-section">
        <h2>Darshan</h2>
        <div className="card-grid card-grid--compact">
          {darshanSections.map((item) => (
            <Link key={item.id} to={item.link} className="card">
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="pravachan-section">
        <h2>Previous HPYM Events</h2>
        <div className="card-grid card-grid--compact">
          {hpymEvents.map((event) => (
            <div
              key={event.id}
              className="card"
              onClick={() => openVideoModal(event.videoId, event.title)}
              role="button"
              tabIndex="0"
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  openVideoModal(event.videoId, event.title);
                }
              }}
            >
              <img src={event.image} alt={event.title} />
              <h3>{event.title}</h3>
            </div>
          ))}
        </div>
      </section>

      <section className="pravachan-section">
        <h2>Centers</h2>
        <div className="card-grid card-grid--compact card-grid--wide">
          <Link to="/centers" className="card">
            <img src="image/center.jpg" alt="Centers" />
            <h3>Centers</h3>
          </Link>
        </div>
      </section>

      <VideoModal
        videoId={selectedVideoId}
        isOpen={isModalOpen}
        onClose={closeModal}
        title={selectedVideoTitle}
      />
    </main>
  );
}

export default Home;
